import useTheme from '@mui/material/styles/useTheme';
import { CalculatedTVBudget } from 'store/planStore';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import { formatNumberWithSpaces } from '../../../../../../../../common/BudgetTable/utils/formatNumberWithSpaces';

export interface TotalTVRowProps {
  data: CalculatedTVBudget;
}

export default function TotalTVRow({ data }: TotalTVRowProps) {
  const totalBudget =
    data.copies?.reduce(
      (acc, copy) => acc + (copy.campaignBudget?.value || 0),
      0
    ) || 0;

  const { palette } = useTheme();
  return (
    <TableRow
      sx={{
        background: palette.oohTable.background.total,
        height: '65px',
        borderTop: '1px solid #8193b4',
      }}
    >
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell align="center">
        <Typography
          textTransform="uppercase"
          sx={{
            color: palette.textLight.main,
            fontWeight: 900,
            fontSize: '14px',
          }}
        >
          Total TV:
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography
          sx={{
            color: palette.textLight.main,
            fontWeight: 900,
            fontSize: '14px',
          }}
        >
          {formatNumberWithSpaces(totalBudget.toFixed(0))}
        </Typography>
      </TableCell>
    </TableRow>
  );
}
